var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDerrickAlt1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 7.90549C14.0439 7.57245 15 6.39788 15 5C15 3.34315 13.6569 2 12 2C10.3431 2 9 3.34315 9 5C9 6.39788 9.95608 7.57245 11.25 7.90549V9.75C11.25 10.1642 11.5858 10.5 12 10.5C12.8284 10.5 13.5 11.1716 13.5 12C13.5 12.8284 12.8284 13.5 12 13.5C11.4322 13.5 10.938 13.1845 10.6834 12.7192C10.4845 12.3559 10.1642 12 9.75 12C9.33579 12 8.99038 12.341 9.09257 12.7424C9.33476 13.6937 10.0316 14.4634 10.938 14.8066L6.14792 18H3C2.44772 18 2 18.4477 2 19V21C2 21.5523 2.44772 22 3 22H21C21.5523 22 22 21.5523 22 21V19C22 18.4477 21.5523 18 21 18H18.7617L13.128 14.7807C14.2258 14.335 15 13.2579 15 12C15 10.6021 14.0439 9.42755 12.75 9.09451V7.90549ZM13 5C13 5.55228 12.5523 6 12 6C11.4477 6 11 5.55228 11 5C11 4.44772 11.4477 4 12 4C12.5523 4 13 4.44772 13 5ZM12.0303 15.8812L15.7383 18H8.85208L12.0303 15.8812Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDerrickAlt1);
export default __webpack_public_path__ + "static/media/derrick-alt-1.35137db64695107acd6784e4071456c4.svg";
export { ForwardRef as ReactComponent };